<template>
  <div id="administrative">
    <div class="con_all">
      <div class="con_box">
        <span class="con_title con_title_line">{{showPage.administrativeMember}}</span>
        <div class="over_ta">
          <div class="con_ta">
            <table>
              <thead>
                <tr>
                  <th width="140">&nbsp;</th>
                  <th width="103">{{showPage.jobTitle}}</th>
                  <th width="110">{{showPage.activityGroup}}</th>
                  <th width="103">{{showPage.name}}</th>
                  <th width="149">{{showPage.officePhone}}</th>
                  <th width="385">{{showPage.business}}</th>
                  <th width="156">{{showPage.agent}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(admin,index) in admins" :key="index" v-if="inCurrentPage(index)">
                  <td class="mobile-img" v-if="admin.profileImage"><img :src="admin.profileImage"></td>
                  <td class="mobile-img" v-if="!admin.profileImage"><img src="/../static/images/timeline-default-photo.gif"></td>
                  
                  <td :data-label="showPage.jobTitle">{{showJobTitle(admin)}}</td>
                  <td :data-label="showPage.activityGroup">{{showGroup(admin)}}</td>
                  <td :data-label="showPage.name">{{showName(admin)}}</td>
                  <td :data-label="showPage.officePhone">{{admin.tel}}</td>
                  <td :data-label="showPage.business" style="text-align: left;">
                    <div v-html="showIntroduction(admin)"></div>
                  </td>
                  <td :data-label="showPage.agent">{{admin.agent}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="pagination-row text-center ml20">
          <Page :total="admins.length" style="margin-top:20px" :page-size="pagesize" @on-change="changePage"></Page>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'administrative',
  data() {
    return {
      admins: [],
      currentPage: 1,
      pagesize: 10,
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initAdmins();
    },
    initAdmins() {
      this.getAdminsData();
    },
    getAdminsData() {
      axios.get(API.admin)
        .then(response => {
          this.admins = response.data.filter(data => {
            return data.trash !== 1;
          });
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage(index) {
      let currentPage = this.currentPage,
        pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize
    },

    showJobTitle(admin) {
      let jobTitle = { 'CH': admin.jobTitleCh, 'EN': admin.jobTitleEn }
      return jobTitle[sessionStorage.locale];
    },
    showGroup(admin) {
      let group = {
        'CH': ['無', '體育教學組', '體育活動組', '場地設備組', '法醫校區體育組', '主任室'],
        'EN': ['none', 'Curriculum Section', 'Activities Section', 'Site Section',
          'Forensic Section', 'Director Office'
        ]
      }
      return group[sessionStorage.locale][admin.activityGroup];
    },
    showName(admin) {
      let name = { 'CH': admin.nameCh, 'EN': admin.nameEn }
      return name[sessionStorage.locale];
    },
    showIntroduction(admin) {
      let introduction = { 'CH': admin.introductionCh, 'EN': admin.introductionEn }
      return introduction[sessionStorage.locale];

    }
  },
}

</script>
<style lang="scss">
/* RWD 手機版樣式 (斷點設為 768px 或你的設計需求) */
@media screen and (max-width: 768px) {
  .con_ta {
    /* 強制將表格元素轉換為區塊元素 */
    table, thead, tbody, th, td, tr {
      display: block;
    }

    /* 隱藏原本的表頭 (但保留結構以利 SEO 或輔助閱讀器) */
    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    /* 每一列變成一張卡片 */
    tr {
      margin-bottom: 20px;
      border: 1px solid #D7DEDF;
      border-radius: 8px;
      background: #fff;
      box-shadow: 0 2px 5px rgba(0,0,0,0.05);
      overflow: hidden;
    }

    /* 每個儲存格的樣式 */
    td {
      border: none;
      border-bottom: 1px solid #eee;
      position: relative;
      padding-left: 35% !important; /* 左邊留給標題 */
      min-height: 45px;
      text-align: left !important;
      white-space: normal;
    }

    /* 最後一個格子不需要底線 */
    td:last-child {
      border-bottom: none;
    }

    /* 利用 :before 偽元素顯示 data-label 的內容 (即標題) */
    td:before {
      content: attr(data-label); /* 抓取 HTML 上的 data-label 值 */
      position: absolute;
      left: 10px;
      width: 30%;
      padding-right: 10px;
      white-space: nowrap;
      font-weight: bold;
      color: #667379;
      background-color: #f9f9f9;
      top: 50%; 
      transform: translateY(-50%); 
    }

    /* 特別處理圖片欄位，讓圖片置中且不需要左側標題 */
    td.mobile-img {
      padding-left: 10px !important;
      text-align: center !important;
      background: #E8EFF0; /* 給圖片區塊一點背景色區隔 */
    }
    
    td.mobile-img:before {
      display: none; /* 圖片不顯示標題 */
    }
    
    td.mobile-img img {
      width: 100px;
      height: 100px;
      object-fit: cover;
      border-radius: 50%; /* 變成圓形頭像比較現代感，可選 */
    }
  }
}

</style>



// WEBPACK FOOTER //
// Administrative.vue?794a9ef5